import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { SucessoComponent } from '../../sucesso/sucesso.component';

@Component({
  selector: 'app-obra-contratada',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SucessoComponent],
  templateUrl: './obra-contratada.component.html',
  styleUrls: ['./obra-contratada.component.scss'],
})
export class ObraContratadaComponent implements OnInit {
  taskDescription = '';
  responsavelSelecionado: string = '';
  responsavel: any[] = [];
  sucesso: boolean = false;
  campoObrigatorioErro: boolean = false;

  @Output() actionConfirmed = new EventEmitter<void>();
  @Input() idObra: number | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() loading = new EventEmitter<boolean>();

  private _errorHandleService = inject(ErrorHandleService);

  constructor(private fichaDaObraService: FichaDaObraService) {}

  ngOnInit(): void {
    this.popularResponsavel();
  }

  clear(): void {
    this.taskDescription = '';
    this.responsavelSelecionado = null;
  }

  continuar() {
    this.sucesso = false;
    this.actionConfirmed.emit();
  }

  popularResponsavel(): void {
    this.fichaDaObraService.popularResponsavelObra().subscribe(
      (response) => {
       this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      }
    );
  }
atualizarObraContratada(): void {
  this.loading.emit(true);

  // Verificação de campo obrigatório
  if (!this.responsavelSelecionado) {
    this.campoObrigatorioErro = true;
    this.loading.emit(false);
    return;
  } else {
    this.campoObrigatorioErro = false;
  }

  if (!this.idObra) {
    console.error('idObra não informado');
    this.loading.emit(false);
    return;
  }

  const body = {
    marketID: 2,
    responsibleID: Number(this.responsavelSelecionado),
    description: this.taskDescription || '',
  };

  this.fichaDaObraService.updateClienteMercado(this.idObra, body).subscribe({
    next: (res) => {
      this.loading.emit(false);
      if (res.success) {
        this.sucesso = true;
      } else {
        this._errorHandleService.throwConsoleError(res.message);
      }
    },
    error: (err) => {
      this.loading.emit(false);
      console.error('Erro ao atualizar obra contratada', err);
      this._errorHandleService.throwConsoleError(err.message);
    },
  });
}
}